export const defaultVertexShader = `#version 300 es

in vec2 a_position;
in vec2 a_texCoord;

uniform mat3 u_camViewProjection;
uniform mat3 u_model;

out vec2 v_texCoord;

void main() {
    mat3 u_matrix = u_camViewProjection * u_model;
    vec3 position = u_matrix * vec3(a_position, 1);
    gl_Position = vec4(position, 1);
    
    v_texCoord = a_texCoord;
}
`;

export const defaultFragmentShader = `#version 300 es

precision highp float;

in vec2 v_texCoord;

uniform bool u_textureExist0;
uniform sampler2D u_texture0;

out vec4 outColor;

void main() {
    vec4 color = vec4(255, 0, 255, 255);
    
    if (u_textureExist0) {
      color = texture(u_texture0, v_texCoord);
    }
    
    outColor = color;
}
`;
